import { requestIdleCallbackPolyfilled } from "./idleCallback";
export var LazyEventKeys;
(function (LazyEventKeys) {
    LazyEventKeys["SetLocalPreferencePosition"] = "set-local-position";
    LazyEventKeys["SetLocalPersistedChatMessages"] = "set-local-persisted-chat-messages";
    LazyEventKeys["RunPhaserLoader"] = "run-phaser-loader";
    LazyEventKeys["CullObjects"] = "phaser-cull";
})(LazyEventKeys || (LazyEventKeys = {}));
const TIMEOUT_MS = 1000;
class LazyScheduler {
    queuedEvents = new Map();
    hasFlushQueued = false;
    counter = 0;
    getQueuedID = () => `${this.counter++}`;
    enqueueEvent = (handler, key) => {
        this.queuedEvents.set(key, handler);
        this.queueEventFlush();
    };
    flushEvents = (deadline) => {
        while ((deadline.timeRemaining() > 0 || deadline.didTimeout) && this.queuedEvents.size) {
            const [key] = this.queuedEvents.keys();
            if (key) {
                this.queuedEvents.get(key)?.();
                this.queuedEvents.delete(key);
            }
        }
        if (this.queuedEvents.size) {
            this.hasFlushQueued = true;
            requestIdleCallbackPolyfilled(this.flushEvents, { timeout: TIMEOUT_MS });
        }
        else {
            this.hasFlushQueued = false;
        }
    };
    queueEventFlush = () => {
        if (this.hasFlushQueued)
            return;
        this.hasFlushQueued = true;
        requestIdleCallbackPolyfilled(this.flushEvents, { timeout: TIMEOUT_MS });
    };
    lazily = (handler, key) => {
        const stringKey = key ?? this.getQueuedID();
        this.enqueueEvent(handler, stringKey);
    };
}
const scheduler = new LazyScheduler();
export const runOnNextIdleCb = scheduler.lazily;
//# sourceMappingURL=lazyScheduler.js.map